import React, { useState, useEffect } from 'react';
import { GH_COLORS } from '../components/Style';
import { apiClient } from '../services/api';

export default function BasicSettingsPage() {
  const [schoolName, setSchoolName] = useState('');
  const [logoPreview, setLogoPreview] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    apiClient.getSettings().then((settings) => {
      if (settings.schoolName) setSchoolName(settings.schoolName);
      if (settings.schoolLogoUrl) setLogoPreview(settings.schoolLogoUrl);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const handleSchoolNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newName = e.target.value;
    setSchoolName(newName);
  };

  const handleSchoolNameBlur = async () => {
    setSaving(true);
    try {
      await apiClient.setSetting('schoolName', schoolName);
      window.dispatchEvent(new CustomEvent('schoolNameChanged', { detail: schoolName }));
    } finally {
      setSaving(false);
    }
  };

  const handleLogoChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setSaving(true);
    try {
      const url = await apiClient.uploadSettingsLogo(file);
      setLogoPreview(url);
      window.dispatchEvent(new CustomEvent('schoolLogoChanged', { detail: url }));
    } finally {
      setSaving(false);
    }
  };

  const handleRemoveLogo = async () => {
    setSaving(true);
    try {
      await apiClient.removeSettingsLogo();
      setLogoPreview(null);
      window.dispatchEvent(new CustomEvent('schoolLogoChanged', { detail: null }));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2 style={{ marginTop: 0, marginBottom: '24px' }}>기본 설정</h2>

      {loading ? (
        <p style={{ color: GH_COLORS.fgMuted }}>불러오는 중...</p>
      ) : (
      <div style={{ maxWidth: '600px' }}>
        {/* 학원 이름 설정 */}
        <div style={{ marginBottom: '32px' }}>
          <label
            style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: 600,
              color: GH_COLORS.fgDefault,
            }}
          >
            학원 이름
          </label>
          <input
            type="text"
            value={schoolName}
            onChange={handleSchoolNameChange}
            onBlur={handleSchoolNameBlur}
            disabled={saving}
            style={{
              width: '100%',
              padding: '10px 12px',
              fontSize: '14px',
              border: `1px solid ${GH_COLORS.border}`,
              borderRadius: '6px',
              color: GH_COLORS.fgDefault,
              boxSizing: 'border-box',
            }}
            placeholder="학원 이름을 입력하세요"
          />
          <p style={{ fontSize: '12px', color: GH_COLORS.fgMuted, marginTop: '6px' }}>
            탑 바 왼쪽에 표시됩니다. (입력 후 클릭 아웃하면 저장됩니다)
          </p>
        </div>

        {/* 학원 로고 설정 */}
        <div style={{ marginBottom: '32px' }}>
          <label
            style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: 600,
              color: GH_COLORS.fgDefault,
            }}
          >
            학원 로고
          </label>

          {logoPreview && (
            <div style={{ marginBottom: '16px' }}>
              <img
                src={logoPreview}
                alt="학원 로고 미리보기"
                style={{
                  maxWidth: '100px',
                  maxHeight: '100px',
                  borderRadius: '6px',
                  border: `1px solid ${GH_COLORS.border}`,
                }}
              />
              <button
                onClick={handleRemoveLogo}
                disabled={saving}
                style={{
                  marginLeft: '12px',
                  padding: '6px 12px',
                  backgroundColor: GH_COLORS.btnDangerBg,
                  color: '#ffffff',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '12px',
                  fontWeight: 600,
                }}
              >
                로고 제거
              </button>
            </div>
          )}

          <input
            type="file"
            accept="image/*"
            onChange={handleLogoChange}
            disabled={saving}
            style={{
              display: 'block',
              marginTop: '8px',
            }}
          />
          <p style={{ fontSize: '12px', color: GH_COLORS.fgMuted, marginTop: '6px' }}>
            학원 이름 왼쪽에 표시됩니다. (JPG, PNG 등 이미지 파일)
          </p>
        </div>
      </div>
      )}
    </div>
  );
}
